import { render, staticRenderFns } from "./GisogdDoc.vue?vue&type=template&id=4f9885fc&scoped=true&"
import script from "./GisogdDoc.vue?vue&type=script&lang=js&"
export * from "./GisogdDoc.vue?vue&type=script&lang=js&"
import style0 from "./GisogdDoc.vue?vue&type=style&index=0&id=4f9885fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9885fc",
  null
  
)

export default component.exports